<template>
  <div class="appDashboard map">
    <div :class="{container:appConfig.container}">
      <app-header :title="title"></app-header>
    </div>
    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="xs12 md12 sm12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout row wrap>
            <v-flex xs12 pl-3 md6 style="height: 50px; line-height: 50px;">
              <span>{{ $t("BatteryPackList.Columns.SerialNo") }}:</span>
              <span class="nameStyle">{{currentSerialNo}}</span>
            </v-flex>
            <v-flex xs12 pr-2 md6 text-right v-if="deviceName !== 'pc'">
              <v-btn depressed color="primary" v-on:click="onClickApp">{{ $t('Map.App')}}</v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div slot="body">
          <div id="map"></div>
        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import mediator from "../../components/common/mediator.vue";
import locale from "../../utility/Locale";
import device from "../../utility/Device";
import proj4 from "proj4";

export default {
  name: "Map",
  mixins: [mediator],
  mounted() {
    this.currentSerialNo = this.publisher("GetSelectSerial", []);
    if(!this.currentSerialNo) return;

    this.setTokyoEPSG();
    this.setMapView();
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      title: $t("Map.Item"),
      currentSerialNo: "",
      uriSchemeForAndroid: "javascript:;",
      uriSchemeForiOS: "javascript:;",
      deviceName: "pc"
    };
  },
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    onClickApp() {},
    setURISchemeInfo() {
      this.deviceName = this.device.getCurrentDevice();
    },
    setMapView() {
      let self = this;

      self.axios
        .get(`${self.$root.url}/Customer/CurrentPosition`, {
          headers: {
            Authorization: `Bearer ${self.$root.token}`
          },
          params: {
            serialNo: self.currentSerialNo
          }
        })
        .then(response => {
          const result = response.data;

          const language = self.publisher("GetServerLanguage", []);
          if (language === "ja-JP") {
            self.setZenrinMap(self.currentSerialNo, result, self);
          } else {
            self.setBaiduMap(self.currentSerialNo, result);
          }
        })
        .catch(error => {
          self.error = true;
          self.result = "Error";
          self.showResult = true;
        });
    },
    setBaiduMap(selectedSerialNo, result) {
      let latitude1 = Number(result.center.latitude); // 緯度
      let longitude1 = Number(result.center.longitude); // 経度

      // ブラウザの言語によって表示する文字を変更
      if (locale.getCurrentLanguage() === "ja") {
        var maptext_serialno = "シリアル番号";
        var maptext_latitude = "緯度";
        var maptext_longitude = "経度";
      } else if (locale.getCurrentLanguage() === 'en' || locale.getCurrentLanguage() === 'en-US') {
        var maptext_serialno = "Serial No";
        var maptext_latitude = "Latitude";
        var maptext_longitude = "Longitude";
      } else {
        var maptext_serialno = "序列号";
        var maptext_latitude = "纬度";
        var maptext_longitude = "经度";
      }

      let center = new BMap.Point(longitude1, latitude1);

      this.setLocationForMobile(latitude1, longitude1);

      let map = new BMap.Map("map");
      map.centerAndZoom(center, 15);
      map.addControl(new BMap.NavigationControl());

      let translateCallback = data => {
        if (data.status === 0) {
          let marker = new BMap.Marker(data.points[0]);
          map.addOverlay(marker);
          map.centerAndZoom(data.points[0], 20);

          var opts = {
            width: 160,
            height: 100,
            title: `${maptext_serialno}: ${selectedSerialNo}`,
            offset: new BMap.Size(0, -20),
            enableCloseOnClick: false,
            enableAutoPan: true
          };
          var infoWindow = new BMap.InfoWindow(
            `${maptext_latitude}: ${latitude1}<br> ${maptext_longitude}: ${longitude1}`,
            opts
          ); // 创建信息窗口对象
          marker.addEventListener("click", function() {
            map.openInfoWindow(infoWindow, data.points[0]); //开启信息窗口
          });
          map.openInfoWindow(infoWindow, map.getCenter()); // 打开信息窗口
        }
      };

      setTimeout(() => {
        let convertor = new BMap.Convertor();
        let pointArr = [];
        pointArr.push(center);
        convertor.translate(pointArr, 1, 5, translateCallback);
      }, 1000);

      result.others.forEach(other => {
        let serialNo2 = other.serialNo;
        let latitude2 = Number(other.latitude); // 緯度
        let longitude2 = Number(other.longitude); // 経度
        let ggPoint = new BMap.Point(longitude2, latitude2);

        let translateCallback = data => {
          if (data.status === 0) {
            let marker = new BMap.Marker(data.points[0]);
            map.addOverlay(marker);

            var opts = {
              width: 160,
              height: 100,
              title: `${maptext_serialno}: ${serialNo2}`,
              offset: new BMap.Size(0, -20),
              enableCloseOnClick: false,
              enableAutoPan: true
            };
            var infoWindow = new BMap.InfoWindow(
              `${maptext_latitude}: ${latitude2}<br> ${maptext_longitude}: ${longitude2}`,
              opts
            ); // 创建信息窗口对象
            marker.addEventListener("click", function() {
              map.openInfoWindow(infoWindow, data.points[0]); //开启信息窗口
            });
            // map.openInfoWindow(infoWindow, map.getCenter()); // 打开信息窗口
          }
        };

        setTimeout(() => {
          let convertor = new BMap.Convertor();
          let pointArr = [];
          pointArr.push(ggPoint);
          convertor.translate(pointArr, 1, 5, translateCallback);
        }, 1000);
      });
    },
    setZenrinMap(selectedSerialNo, result, self) {
      const ans = self.world2japan(result.center.longitude, result.center.latitude);

      const latitude = result.center.latitude; // 緯度
      const longitude = result.center.longitude; // 経度

      // ブラウザの言語によって表示する文字を変更
      if (locale.getCurrentLanguage() === "ja") {
        var maptext_serialno = "シリアル番号";
        var maptext_latitude = "緯度";
        var maptext_longitude = "経度";
      } else if (locale.getCurrentLanguage() === 'en' || locale.getCurrentLanguage() === 'en-US') {
        var maptext_serialno = "Serial No";
        var maptext_latitude = "Latitude";
        var maptext_longitude = "Longitude";
      } else {
        var maptext_serialno = "序列号";
        var maptext_latitude = "纬度";
        var maptext_longitude = "经度";
      }

      let center = new ZDC.LatLon(ans[1], ans[0]);
      let map = new ZDC.Map(document.getElementById("map"), {
        latlon: center,
        zoom: 15,
        title: `序列号: ${selectedSerialNo}`,
        mapType: ZDC.MAPTYPE_HIGHRES_LV18
      });

      /* マーカを作成 */
      let mrk = new ZDC.Marker(center);
      map.addWidget(mrk);

      /* 吹き出しを作成 */
      let widget = new ZDC.MsgInfo(center, {
        html: `${maptext_serialno}: ${selectedSerialNo}<br>${maptext_latitude}: ${latitude}<br>${maptext_longitude}: ${longitude}`,
        offset: ZDC.Pixel(0, -18)
      });

      map.addWidget(widget);
      widget.open();

      // 地図上にコントローラを表示
      let widget_normal = new ZDC.Control({
        pos: {
          top: 10,
          left: 10
        },
        type: ZDC.CTRL_TYPE_NORMAL
      });
      map.addWidget(widget_normal);

      ZDC.addListener(mrk, ZDC.MARKER_MOUSEUP, () => {
        widget.open();
      });

      // その他のマーカーがうまく表示されないバグの修正
      result.others.forEach(other => {
        const serialNo2 = other.serialNo;
        const latitude2 = Number(other.latitude); // 緯度
        const longitude2 = Number(other.longitude);  // 経度

        let otherLation = new ZDC.LatLon(latitude2, longitude2);
        let mrk2 = new ZDC.Marker(otherLation);
        map.addWidget(mrk2);

        let otherWidget = new ZDC.MsgInfo(otherLation,
          {
            html: `${maptext_serialno}: ${serialNo2}<br>${maptext_latitude}: ${latitude2}<br>${maptext_longitude}: ${longitude2}`,
            offset: ZDC.Pixel(0, -18)
          });

        map.addWidget(otherWidget);

        ZDC.addListener(mrk2, ZDC.MARKER_MOUSEUP, () => {
          otherWidget.open();
        });
      });

    },
    setTokyoEPSG() {
      (proj4).defs([
        ["EPSG:4301", //東京測地系/日本測地系 SRID=4301
          "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +no_defs"
        ]
      ]);
    },
    world2japan(lon, lat) {
      return proj4("EPSG:4326", "EPSG:4301", [lon, lat]);
    },
    setLocationForMobile(latitude, longitude) {
      this.uriSchemeForAndroid = `baidumap://map/show?center=${latitude},${longitude}&zoom=11`;
      this.uriSchemeForiOS = `baidumap://map/marker?location=${latitude},${longitude}&zoom=11`;
    },
  }
};
</script>

<style>
.map {
  z-index: 9;
}
.map .offset-sm3 {
  margin: 0 !important;
  flex-basis: 100% !important;
  max-width: 100% !important;
}
#map {
  width: 100%;
  height: 500px;
}
.nameStyle {
  color: rgb(22, 135, 171);
  margin-left: 10px;
}
</style>


<!--====  End of DASHBOAR2  ====-->



// WEBPACK FOOTER //
// src/router/Customer/Map.vue